import "./contact.3c53636b.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired972"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired972"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2PKE5", function(module, exports) {

$parcel$export(module.exports, "SplitText", () => $2104870241a7ba6f$export$bd0fa428528371b2);
/*!
 * SplitText 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved. Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle
 */ let $2104870241a7ba6f$var$gsap, $2104870241a7ba6f$var$_fonts, $2104870241a7ba6f$var$_coreInitted, $2104870241a7ba6f$var$_initIfNecessary = ()=>$2104870241a7ba6f$var$_coreInitted || $2104870241a7ba6f$export$bd0fa428528371b2.register(window.gsap), $2104870241a7ba6f$var$_charSegmenter = typeof Intl !== "undefined" ? new Intl.Segmenter() : 0, $2104870241a7ba6f$var$_toArray = (r)=>typeof r === "string" ? $2104870241a7ba6f$var$_toArray(document.querySelectorAll(r)) : "length" in r ? Array.from(r) : [
        r
    ], $2104870241a7ba6f$var$_elements = (targets)=>$2104870241a7ba6f$var$_toArray(targets).filter((e)=>e instanceof HTMLElement), $2104870241a7ba6f$var$_emptyArray = [], $2104870241a7ba6f$var$_context = function() {}, $2104870241a7ba6f$var$_spacesRegEx = /\s+/g, $2104870241a7ba6f$var$_emojiSafeRegEx = new RegExp("\\p{RI}\\p{RI}|\\p{Emoji}(\\p{EMod}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Emoji}(\\p{EMod}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*|.", "gu"), $2104870241a7ba6f$var$_emptyBounds = {
    left: 0,
    top: 0,
    width: 0,
    height: 0
}, $2104870241a7ba6f$var$_stretchToFitSpecialChars = (collection, specialCharsRegEx)=>{
    if (specialCharsRegEx) {
        let charsFound = new Set(collection.join("").match(specialCharsRegEx) || $2104870241a7ba6f$var$_emptyArray), i = collection.length, slots, word, char, combined;
        if (charsFound.size) while(--i > -1){
            word = collection[i];
            for (char of charsFound)if (char.startsWith(word) && char.length > word.length) {
                slots = 0;
                combined = word;
                while(char.startsWith(combined += collection[i + ++slots]) && combined.length < char.length);
                if (slots && combined.length === char.length) {
                    collection[i] = char;
                    collection.splice(i + 1, slots);
                    break;
                }
            }
        }
    }
    return collection;
}, $2104870241a7ba6f$var$_disallowInline = (element)=>window.getComputedStyle(element).display === "inline" && (element.style.display = "inline-block"), $2104870241a7ba6f$var$_insertNodeBefore = (newChild, parent, existingChild)=>parent.insertBefore(typeof newChild === "string" ? document.createTextNode(newChild) : newChild, existingChild), $2104870241a7ba6f$var$_getWrapper = (type, config, collection)=>{
    let className = config[type + "sClass"] || "", { tag: tag = "div", aria: aria = "auto", propIndex: propIndex = false } = config, display = type === "line" ? "block" : "inline-block", incrementClass = className.indexOf("++") > -1, wrapper = (text)=>{
        let el = document.createElement(tag), i = collection.length + 1;
        className && (el.className = className + (incrementClass ? " " + className + i : ""));
        propIndex && el.style.setProperty("--" + type, i + "");
        aria !== "none" && el.setAttribute("aria-hidden", "true");
        if (tag !== "span") {
            el.style.position = "relative";
            el.style.display = display;
        }
        el.textContent = text;
        collection.push(el);
        return el;
    };
    incrementClass && (className = className.replace("++", ""));
    wrapper.collection = collection;
    return wrapper;
}, $2104870241a7ba6f$var$_getLineWrapper = (element, nodes, config, collection)=>{
    let lineWrapper = $2104870241a7ba6f$var$_getWrapper("line", config, collection), textAlign = window.getComputedStyle(element).textAlign || "left";
    return (startIndex, endIndex)=>{
        let newLine = lineWrapper("");
        newLine.style.textAlign = textAlign;
        element.insertBefore(newLine, nodes[startIndex]);
        for(; startIndex < endIndex; startIndex++)newLine.appendChild(nodes[startIndex]);
        newLine.normalize();
    };
}, $2104870241a7ba6f$var$_splitWordsAndCharsRecursively = (element, config, wordWrapper, charWrapper, prepForCharsOnly, deepSlice, ignore, charSplitRegEx, specialCharsRegEx, isNested)=>{
    var _a;
    let nodes = Array.from(element.childNodes), i = 0, { wordDelimiter: wordDelimiter, reduceWhiteSpace: reduceWhiteSpace = true, prepareText: prepareText } = config, elementBounds = element.getBoundingClientRect(), lastBounds = elementBounds, isPreformatted = !reduceWhiteSpace && window.getComputedStyle(element).whiteSpace.substring(0, 3) === "pre", ignoredPreviousSibling = 0, wordsCollection = wordWrapper.collection, wordDelimIsNotSpace, wordDelimString, wordDelimSplitter, curNode, words, curWordEl, startsWithSpace, endsWithSpace, j, bounds, curWordChars, clonedNode, curSubNode, tempSubNode, curTextContent, wordText, lastWordText, k;
    if (typeof wordDelimiter === "object") {
        wordDelimSplitter = wordDelimiter.delimiter || wordDelimiter;
        wordDelimString = wordDelimiter.replaceWith || "";
    } else wordDelimString = wordDelimiter === "" ? "" : wordDelimiter || " ";
    wordDelimIsNotSpace = wordDelimString !== " ";
    for(; i < nodes.length; i++){
        curNode = nodes[i];
        if (curNode.nodeType === 3) {
            curTextContent = curNode.textContent || "";
            if (reduceWhiteSpace) curTextContent = curTextContent.replace($2104870241a7ba6f$var$_spacesRegEx, " ");
            else if (isPreformatted) curTextContent = curTextContent.replace(/\n/g, wordDelimString + "\n");
            prepareText && (curTextContent = prepareText(curTextContent, element));
            curNode.textContent = curTextContent;
            words = wordDelimString || wordDelimSplitter ? curTextContent.split(wordDelimSplitter || wordDelimString) : curTextContent.match(charSplitRegEx) || $2104870241a7ba6f$var$_emptyArray;
            lastWordText = words[words.length - 1];
            endsWithSpace = wordDelimIsNotSpace ? lastWordText.slice(-1) === " " : !lastWordText;
            lastWordText || words.pop();
            lastBounds = elementBounds;
            startsWithSpace = wordDelimIsNotSpace ? words[0].charAt(0) === " " : !words[0];
            startsWithSpace && $2104870241a7ba6f$var$_insertNodeBefore(" ", element, curNode);
            words[0] || words.shift();
            $2104870241a7ba6f$var$_stretchToFitSpecialChars(words, specialCharsRegEx);
            deepSlice && isNested || (curNode.textContent = "");
            for(j = 1; j <= words.length; j++){
                wordText = words[j - 1];
                if (!reduceWhiteSpace && isPreformatted && wordText.charAt(0) === "\n") {
                    (_a = curNode.previousSibling) == null || _a.remove();
                    $2104870241a7ba6f$var$_insertNodeBefore(document.createElement("br"), element, curNode);
                    wordText = wordText.slice(1);
                }
                if (!reduceWhiteSpace && wordText === "") $2104870241a7ba6f$var$_insertNodeBefore(wordDelimString, element, curNode);
                else if (wordText === " ") element.insertBefore(document.createTextNode(" "), curNode);
                else {
                    wordDelimIsNotSpace && wordText.charAt(0) === " " && $2104870241a7ba6f$var$_insertNodeBefore(" ", element, curNode);
                    if (ignoredPreviousSibling && j === 1 && !startsWithSpace && wordsCollection.indexOf(ignoredPreviousSibling.parentNode) > -1) {
                        curWordEl = wordsCollection[wordsCollection.length - 1];
                        curWordEl.appendChild(document.createTextNode(charWrapper ? "" : wordText));
                    } else {
                        curWordEl = wordWrapper(charWrapper ? "" : wordText);
                        $2104870241a7ba6f$var$_insertNodeBefore(curWordEl, element, curNode);
                        ignoredPreviousSibling && j === 1 && !startsWithSpace && curWordEl.insertBefore(ignoredPreviousSibling, curWordEl.firstChild);
                    }
                    if (charWrapper) {
                        curWordChars = $2104870241a7ba6f$var$_charSegmenter ? $2104870241a7ba6f$var$_stretchToFitSpecialChars([
                            ...$2104870241a7ba6f$var$_charSegmenter.segment(wordText)
                        ].map((s)=>s.segment), specialCharsRegEx) : wordText.match(charSplitRegEx) || $2104870241a7ba6f$var$_emptyArray;
                        for(k = 0; k < curWordChars.length; k++)curWordEl.appendChild(curWordChars[k] === " " ? document.createTextNode(" ") : charWrapper(curWordChars[k]));
                    }
                    if (deepSlice && isNested) {
                        curTextContent = curNode.textContent = curTextContent.substring(wordText.length + 1, curTextContent.length);
                        bounds = curWordEl.getBoundingClientRect();
                        if (bounds.top > lastBounds.top && bounds.left <= lastBounds.left) {
                            clonedNode = element.cloneNode();
                            curSubNode = element.childNodes[0];
                            while(curSubNode && curSubNode !== curWordEl){
                                tempSubNode = curSubNode;
                                curSubNode = curSubNode.nextSibling;
                                clonedNode.appendChild(tempSubNode);
                            }
                            element.parentNode.insertBefore(clonedNode, element);
                            prepForCharsOnly && $2104870241a7ba6f$var$_disallowInline(clonedNode);
                        }
                        lastBounds = bounds;
                    }
                    if (j < words.length || endsWithSpace) $2104870241a7ba6f$var$_insertNodeBefore(j >= words.length ? " " : wordDelimIsNotSpace && wordText.slice(-1) === " " ? " " + wordDelimString : wordDelimString, element, curNode);
                }
            }
            element.removeChild(curNode);
            ignoredPreviousSibling = 0;
        } else if (curNode.nodeType === 1) {
            if (ignore && ignore.indexOf(curNode) > -1) {
                wordsCollection.indexOf(curNode.previousSibling) > -1 && wordsCollection[wordsCollection.length - 1].appendChild(curNode);
                ignoredPreviousSibling = curNode;
            } else {
                $2104870241a7ba6f$var$_splitWordsAndCharsRecursively(curNode, config, wordWrapper, charWrapper, prepForCharsOnly, deepSlice, ignore, charSplitRegEx, specialCharsRegEx, true);
                ignoredPreviousSibling = 0;
            }
            prepForCharsOnly && $2104870241a7ba6f$var$_disallowInline(curNode);
        }
    }
};
const $2104870241a7ba6f$var$_SplitText = class _SplitText {
    constructor(elements, config){
        this.isSplit = false;
        $2104870241a7ba6f$var$_initIfNecessary();
        this.elements = $2104870241a7ba6f$var$_elements(elements);
        this.chars = [];
        this.words = [];
        this.lines = [];
        this.masks = [];
        this.vars = config;
        this._split = ()=>this.isSplit && this.split(this.vars);
        let orig = [], timerId, checkWidths = ()=>{
            let i = orig.length, o;
            while(i--){
                o = orig[i];
                let w = o.element.offsetWidth;
                if (w !== o.width) {
                    o.width = w;
                    this._split();
                    return;
                }
            }
        };
        this._data = {
            orig: orig,
            obs: typeof ResizeObserver !== "undefined" && new ResizeObserver(()=>{
                clearTimeout(timerId);
                timerId = setTimeout(checkWidths, 200);
            })
        };
        $2104870241a7ba6f$var$_context(this);
        this.split(config);
    }
    split(config) {
        this.isSplit && this.revert();
        this.vars = config = config || this.vars || {};
        let { type: type = "chars,words,lines", aria: aria = "auto", deepSlice: deepSlice = true, smartWrap: smartWrap, onSplit: onSplit, autoSplit: autoSplit = false, specialChars: specialChars, mask: mask } = this.vars, splitLines = type.indexOf("lines") > -1, splitCharacters = type.indexOf("chars") > -1, splitWords = type.indexOf("words") > -1, onlySplitCharacters = splitCharacters && !splitWords && !splitLines, specialCharsRegEx = specialChars && ("push" in specialChars ? new RegExp("(?:" + specialChars.join("|") + ")", "gu") : specialChars), finalCharSplitRegEx = specialCharsRegEx ? new RegExp(specialCharsRegEx.source + "|" + $2104870241a7ba6f$var$_emojiSafeRegEx.source, "gu") : $2104870241a7ba6f$var$_emojiSafeRegEx, ignore = !!config.ignore && $2104870241a7ba6f$var$_elements(config.ignore), { orig: orig, animTime: animTime, obs: obs } = this._data, onSplitResult;
        if (splitCharacters || splitWords || splitLines) {
            this.elements.forEach((element, index)=>{
                orig[index] = {
                    element: element,
                    html: element.innerHTML,
                    ariaL: element.getAttribute("aria-label"),
                    ariaH: element.getAttribute("aria-hidden")
                };
                aria === "auto" ? element.setAttribute("aria-label", (element.textContent || "").trim()) : aria === "hidden" && element.setAttribute("aria-hidden", "true");
                let chars = [], words = [], lines = [], charWrapper = splitCharacters ? $2104870241a7ba6f$var$_getWrapper("char", config, chars) : null, wordWrapper = $2104870241a7ba6f$var$_getWrapper("word", config, words), i, curWord, smartWrapSpan, nextSibling;
                $2104870241a7ba6f$var$_splitWordsAndCharsRecursively(element, config, wordWrapper, charWrapper, onlySplitCharacters, deepSlice && (splitLines || onlySplitCharacters), ignore, finalCharSplitRegEx, specialCharsRegEx, false);
                if (splitLines) {
                    let nodes = $2104870241a7ba6f$var$_toArray(element.childNodes), wrapLine = $2104870241a7ba6f$var$_getLineWrapper(element, nodes, config, lines), curNode, toRemove = [], lineStartIndex = 0, allBounds = nodes.map((n)=>n.nodeType === 1 ? n.getBoundingClientRect() : $2104870241a7ba6f$var$_emptyBounds), lastBounds = $2104870241a7ba6f$var$_emptyBounds;
                    for(i = 0; i < nodes.length; i++){
                        curNode = nodes[i];
                        if (curNode.nodeType === 1) {
                            if (curNode.nodeName === "BR") {
                                toRemove.push(curNode);
                                wrapLine(lineStartIndex, i + 1);
                                lineStartIndex = i + 1;
                                lastBounds = allBounds[lineStartIndex];
                            } else {
                                if (i && allBounds[i].top > lastBounds.top && allBounds[i].left <= lastBounds.left) {
                                    wrapLine(lineStartIndex, i);
                                    lineStartIndex = i;
                                }
                                lastBounds = allBounds[i];
                            }
                        }
                    }
                    lineStartIndex < i && wrapLine(lineStartIndex, i);
                    toRemove.forEach((el)=>{
                        var _a;
                        return (_a = el.parentNode) == null ? void 0 : _a.removeChild(el);
                    });
                }
                if (!splitWords) {
                    for(i = 0; i < words.length; i++){
                        curWord = words[i];
                        if (splitCharacters || !curWord.nextSibling || curWord.nextSibling.nodeType !== 3) {
                            if (smartWrap && !splitLines) {
                                smartWrapSpan = document.createElement("span");
                                smartWrapSpan.style.whiteSpace = "nowrap";
                                while(curWord.firstChild)smartWrapSpan.appendChild(curWord.firstChild);
                                curWord.replaceWith(smartWrapSpan);
                            } else curWord.replaceWith(...curWord.childNodes);
                        } else {
                            nextSibling = curWord.nextSibling;
                            if (nextSibling && nextSibling.nodeType === 3) {
                                nextSibling.textContent = (curWord.textContent || "") + (nextSibling.textContent || "");
                                curWord.remove();
                            }
                        }
                    }
                    words.length = 0;
                    element.normalize();
                }
                this.lines.push(...lines);
                this.words.push(...words);
                this.chars.push(...chars);
            });
            mask && this[mask] && this.masks.push(...this[mask].map((el)=>{
                let maskEl = el.cloneNode();
                el.replaceWith(maskEl);
                maskEl.appendChild(el);
                el.className && (maskEl.className = el.className.replace(/(\b\w+\b)/g, "$1-mask"));
                maskEl.style.overflow = "clip";
                return maskEl;
            }));
        }
        this.isSplit = true;
        $2104870241a7ba6f$var$_fonts && (autoSplit ? $2104870241a7ba6f$var$_fonts.addEventListener("loadingdone", this._split) : $2104870241a7ba6f$var$_fonts.status === "loading" && console.warn("SplitText called before fonts loaded"));
        if ((onSplitResult = onSplit && onSplit(this)) && onSplitResult.totalTime) this._data.anim = animTime ? onSplitResult.totalTime(animTime) : onSplitResult;
        splitLines && autoSplit && this.elements.forEach((element, index)=>{
            orig[index].width = element.offsetWidth;
            obs && obs.observe(element);
        });
        return this;
    }
    revert() {
        var _a, _b;
        let { orig: orig, anim: anim, obs: obs } = this._data;
        obs && obs.disconnect();
        orig.forEach(({ element: element, html: html, ariaL: ariaL, ariaH: ariaH })=>{
            element.innerHTML = html;
            ariaL ? element.setAttribute("aria-label", ariaL) : element.removeAttribute("aria-label");
            ariaH ? element.setAttribute("aria-hidden", ariaH) : element.removeAttribute("aria-hidden");
        });
        this.chars.length = this.words.length = this.lines.length = orig.length = this.masks.length = 0;
        this.isSplit = false;
        $2104870241a7ba6f$var$_fonts == null || $2104870241a7ba6f$var$_fonts.removeEventListener("loadingdone", this._split);
        if (anim) {
            this._data.animTime = anim.totalTime();
            anim.revert();
        }
        (_b = (_a = this.vars).onRevert) == null || _b.call(_a, this);
        return this;
    }
    static create(elements, config) {
        return new _SplitText(elements, config);
    }
    static register(core) {
        $2104870241a7ba6f$var$gsap = $2104870241a7ba6f$var$gsap || core || window.gsap;
        if ($2104870241a7ba6f$var$gsap) {
            $2104870241a7ba6f$var$_toArray = $2104870241a7ba6f$var$gsap.utils.toArray;
            $2104870241a7ba6f$var$_context = $2104870241a7ba6f$var$gsap.core.context || $2104870241a7ba6f$var$_context;
        }
        if (!$2104870241a7ba6f$var$_coreInitted && window.innerWidth > 0) {
            $2104870241a7ba6f$var$_fonts = document.fonts;
            $2104870241a7ba6f$var$_coreInitted = true;
        }
    }
};
$2104870241a7ba6f$var$_SplitText.version = "3.13.0";
let $2104870241a7ba6f$export$bd0fa428528371b2 = $2104870241a7ba6f$var$_SplitText;

});


var $4AGbv = parcelRequire("4AGbv");
/*!
 * ScrambleTextPlugin 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ /*!
 * strings: 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $8d15f3b4c86370d0$var$_trimExp = /(?:^\s+|\s+$)/g;
var $8d15f3b4c86370d0$export$8c0236acf4c550c0 = /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2642\u2640]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDD27\uDCBC\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCC\uDFCB]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
function $8d15f3b4c86370d0$export$c72d34660a162238(e) {
    var type = e.nodeType, result = "";
    if (type === 1 || type === 9 || type === 11) {
        if (typeof e.textContent === "string") return e.textContent;
        else for(e = e.firstChild; e; e = e.nextSibling)result += $8d15f3b4c86370d0$export$c72d34660a162238(e);
    } else if (type === 3 || type === 4) return e.nodeValue;
    return result;
}
function $8d15f3b4c86370d0$export$998040109c806e97(element, delimiter, trim, preserveSpaces, unescapedCharCodes) {
    var node = element.firstChild, result = [], s;
    while(node){
        if (node.nodeType === 3) {
            s = (node.nodeValue + "").replace(/^\n+/g, "");
            if (!preserveSpaces) s = s.replace(/\s+/g, " ");
            result.push.apply(result, $8d15f3b4c86370d0$export$9cce64ee9e7efffe(s, delimiter, trim, preserveSpaces, unescapedCharCodes));
        } else if ((node.nodeName + "").toLowerCase() === "br") result[result.length - 1] += "<br>";
        else result.push(node.outerHTML);
        node = node.nextSibling;
    }
    if (!unescapedCharCodes) {
        s = result.length;
        while(s--)result[s] === "&" && result.splice(s, 1, "&amp;");
    }
    return result;
}
function $8d15f3b4c86370d0$export$9cce64ee9e7efffe(text, delimiter, trim, preserveSpaces, unescapedCharCodes) {
    text += ""; // make sure it's cast as a string. Someone may pass in a number.
    trim && (text = text.trim ? text.trim() : text.replace($8d15f3b4c86370d0$var$_trimExp, "")); // IE9 and earlier compatibility
    if (delimiter && delimiter !== "") return text.replace(/>/g, "&gt;").replace(/</g, "&lt;").split(delimiter);
    var result = [], l = text.length, i = 0, j, character;
    for(; i < l; i++){
        character = text.charAt(i);
        if (character.charCodeAt(0) >= 0xD800 && character.charCodeAt(0) <= 0xDBFF || text.charCodeAt(i + 1) >= 0xFE00 && text.charCodeAt(i + 1) <= 0xFE0F) {
            //special emoji characters use 2 or 4 unicode characters that we must keep together.
            j = ((text.substr(i, 12).split($8d15f3b4c86370d0$export$8c0236acf4c550c0) || [])[1] || "").length || 2;
            character = text.substr(i, j);
            result.emoji = 1;
            i += j - 1;
        }
        result.push(unescapedCharCodes ? character : character === ">" ? "&gt;" : character === "<" ? "&lt;" : preserveSpaces && character === " " && (text.charAt(i - 1) === " " || text.charAt(i + 1) === " ") ? "&nbsp;" : character);
    }
    return result;
}


var $249ec7e572a7bdb2$var$CharSet = /*#__PURE__*/ function() {
    function CharSet(chars) {
        this.chars = (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)(chars);
        this.sets = [];
        this.length = 50;
        for(var i = 0; i < 20; i++)this.sets[i] = $249ec7e572a7bdb2$var$_scrambleText(80, this.chars); //we create 20 strings that are 80 characters long, randomly chosen and pack them into an array. We then randomly choose the scrambled text from this array in order to greatly improve efficiency compared to creating new randomized text from scratch each and every time it's needed. This is a simple lookup whereas the other technique requires looping through as many times as there are characters needed, and calling Math.random() each time through the loop, building the string, etc.
    }
    var _proto = CharSet.prototype;
    _proto.grow = function grow(newLength) {
        //if we encounter a tween that has more than 80 characters, we'll need to add to the character sets accordingly. Once it's cached, it'll only need to grow again if we exceed that new length. Again, this is an efficiency tactic.
        for(var i = 0; i < 20; i++)this.sets[i] += $249ec7e572a7bdb2$var$_scrambleText(newLength - this.length, this.chars);
        this.length = newLength;
    };
    return CharSet;
}();
var $249ec7e572a7bdb2$var$gsap, $249ec7e572a7bdb2$var$_coreInitted, $249ec7e572a7bdb2$var$_getGSAP = function _getGSAP() {
    return $249ec7e572a7bdb2$var$gsap || typeof window !== "undefined" && ($249ec7e572a7bdb2$var$gsap = window.gsap) && $249ec7e572a7bdb2$var$gsap.registerPlugin && $249ec7e572a7bdb2$var$gsap;
}, $249ec7e572a7bdb2$var$_bonusValidated = 1, //<name>ScrambleTextPlugin</name>
$249ec7e572a7bdb2$var$_spacesExp = /\s+/g, $249ec7e572a7bdb2$var$_scrambleText = function _scrambleText(length, chars) {
    var l = chars.length, s = "";
    while(--length > -1)s += chars[~~(Math.random() * l)];
    return s;
}, $249ec7e572a7bdb2$var$_upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", $249ec7e572a7bdb2$var$_lower = $249ec7e572a7bdb2$var$_upper.toLowerCase(), $249ec7e572a7bdb2$var$_charsLookup = {
    upperCase: new $249ec7e572a7bdb2$var$CharSet($249ec7e572a7bdb2$var$_upper),
    lowerCase: new $249ec7e572a7bdb2$var$CharSet($249ec7e572a7bdb2$var$_lower),
    upperAndLowerCase: new $249ec7e572a7bdb2$var$CharSet($249ec7e572a7bdb2$var$_upper + $249ec7e572a7bdb2$var$_lower)
}, $249ec7e572a7bdb2$var$_initCore = function _initCore() {
    $249ec7e572a7bdb2$var$_coreInitted = $249ec7e572a7bdb2$var$gsap = $249ec7e572a7bdb2$var$_getGSAP();
};
var $249ec7e572a7bdb2$export$33be2495fb0a473a = {
    version: "3.13.0",
    name: "scrambleText",
    register: function register(core, Plugin, propTween) {
        $249ec7e572a7bdb2$var$gsap = core;
        $249ec7e572a7bdb2$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        $249ec7e572a7bdb2$var$_coreInitted || $249ec7e572a7bdb2$var$_initCore();
        this.prop = "innerHTML" in target ? "innerHTML" : "textContent" in target ? "textContent" : 0; // SVG text in IE doesn't have innerHTML, but it does have textContent.
        if (!this.prop) return;
        this.target = target;
        if (typeof value !== "object") value = {
            text: value
        };
        var text = value.text || value.value || "", trim = value.trim !== false, data = this, delim, maxLength, charset, splitByChars;
        data.delimiter = delim = value.delimiter || "";
        data.original = (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)((0, $8d15f3b4c86370d0$export$c72d34660a162238)(target).replace($249ec7e572a7bdb2$var$_spacesExp, " ").split("&nbsp;").join(""), delim, trim);
        if (text === "{original}" || text === true || text == null) text = data.original.join(delim);
        data.text = (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)((text || "").replace($249ec7e572a7bdb2$var$_spacesExp, " "), delim, trim);
        data.hasClass = !!(value.newClass || value.oldClass);
        data.newClass = value.newClass;
        data.oldClass = value.oldClass;
        splitByChars = delim === "";
        data.textHasEmoji = splitByChars && !!data.text.emoji;
        data.charsHaveEmoji = !!value.chars && !!(0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)(value.chars).emoji;
        data.length = splitByChars ? data.original.length : data.original.join(delim).length;
        data.lengthDif = (splitByChars ? data.text.length : data.text.join(delim).length) - data.length;
        data.fillChar = value.fillChar || value.chars && ~value.chars.indexOf(" ") ? "&nbsp;" : "";
        data.charSet = charset = $249ec7e572a7bdb2$var$_charsLookup[value.chars || "upperCase"] || new $249ec7e572a7bdb2$var$CharSet(value.chars);
        data.speed = 0.05 / (value.speed || 1);
        data.prevScrambleTime = 0;
        data.setIndex = Math.random() * 20 | 0;
        maxLength = data.length + Math.max(data.lengthDif, 0);
        if (maxLength > charset.length) charset.grow(maxLength);
        data.chars = charset.sets[data.setIndex];
        data.revealDelay = value.revealDelay || 0;
        data.tweenLength = value.tweenLength !== false;
        data.tween = tween;
        data.rightToLeft = !!value.rightToLeft;
        data._props.push("scrambleText", "text");
        return $249ec7e572a7bdb2$var$_bonusValidated;
    },
    render: function render(ratio, data) {
        var target = data.target, prop = data.prop, text = data.text, delimiter = data.delimiter, tween = data.tween, prevScrambleTime = data.prevScrambleTime, revealDelay = data.revealDelay, setIndex = data.setIndex, chars = data.chars, charSet = data.charSet, length = data.length, textHasEmoji = data.textHasEmoji, charsHaveEmoji = data.charsHaveEmoji, lengthDif = data.lengthDif, tweenLength = data.tweenLength, oldClass = data.oldClass, newClass = data.newClass, rightToLeft = data.rightToLeft, fillChar = data.fillChar, speed = data.speed, original = data.original, hasClass = data.hasClass, l = text.length, time = tween._time, timeDif = time - prevScrambleTime, i, i2, startText, endText, applyNew, applyOld, str, startClass, endClass, position, r;
        if (revealDelay) {
            if (tween._from) time = tween._dur - time; //invert the time for from() tweens
            ratio = time === 0 ? 0 : time < revealDelay ? 0.000001 : time === tween._dur ? 1 : tween._ease((time - revealDelay) / (tween._dur - revealDelay));
        }
        if (ratio < 0) ratio = 0;
        else if (ratio > 1) ratio = 1;
        if (rightToLeft) ratio = 1 - ratio;
        i = ~~(ratio * l + 0.5);
        if (ratio) {
            if (timeDif > speed || timeDif < -speed) {
                data.setIndex = setIndex = (setIndex + (Math.random() * 19 | 0)) % 20;
                data.chars = charSet.sets[setIndex];
                data.prevScrambleTime += timeDif;
            }
            endText = chars;
        } else endText = original.join(delimiter);
        r = tween._from ? ratio : 1 - ratio;
        position = length + (tweenLength ? tween._from ? r * r * r : 1 - r * r * r : 1) * lengthDif;
        if (rightToLeft) {
            if (ratio === 1 && (tween._from || tween.data === "isFromStart")) {
                //special case for from() tweens
                startText = "";
                endText = original.join(delimiter);
            } else {
                str = text.slice(i).join(delimiter);
                if (charsHaveEmoji) startText = (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)(endText).slice(0, position - (textHasEmoji ? (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)(str) : str).length + 0.5 | 0).join("");
                else startText = endText.substr(0, position - (textHasEmoji ? (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)(str) : str).length + 0.5 | 0);
                endText = str;
            }
        } else {
            startText = text.slice(0, i).join(delimiter);
            i2 = (textHasEmoji ? (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)(startText) : startText).length;
            if (charsHaveEmoji) endText = (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe)(endText).slice(i2, position + 0.5 | 0).join("");
            else endText = endText.substr(i2, position - i2 + 0.5 | 0);
        }
        if (hasClass) {
            startClass = rightToLeft ? oldClass : newClass;
            endClass = rightToLeft ? newClass : oldClass;
            applyNew = startClass && i !== 0;
            applyOld = endClass && i !== l;
            str = (applyNew ? "<span class='" + startClass + "'>" : "") + startText + (applyNew ? "</span>" : "") + (applyOld ? "<span class='" + endClass + "'>" : "") + delimiter + endText + (applyOld ? "</span>" : "");
        } else str = startText + delimiter + endText;
        target[prop] = fillChar === "&nbsp;" && ~str.indexOf("  ") ? str.split("  ").join("&nbsp;&nbsp;") : str;
    }
};
$249ec7e572a7bdb2$export$33be2495fb0a473a.emojiSafeSplit = (0, $8d15f3b4c86370d0$export$9cce64ee9e7efffe);
$249ec7e572a7bdb2$export$33be2495fb0a473a.getText = (0, $8d15f3b4c86370d0$export$c72d34660a162238);
$249ec7e572a7bdb2$var$_getGSAP() && $249ec7e572a7bdb2$var$gsap.registerPlugin($249ec7e572a7bdb2$export$33be2495fb0a473a);


var $beOXE = parcelRequire("beOXE");
var $iNA1s = parcelRequire("iNA1s");
var $2PKE5 = parcelRequire("2PKE5");
// let smoke = document.getElementById("smoke");
// function createSmoke(e) {
//   let elem = document.createElement("div");
//   elem.classList.add(`elem`);
//   elem.style.left = `${e.clientX}px`;
//   elem.style.top = `${e.clientY}px`;
//   smoke.appendChild(elem);
//   elem.addEventListener("animationend", () => {
//     elem.remove();
//   });
// }
// document.addEventListener("mousemove", createSmoke);
// Nav Btn
const $c1ce9d969bfa6909$var$NavBtn = document.querySelector(".header-container__onbox-navbtn__btn");
const $c1ce9d969bfa6909$var$NavBarPage = document.querySelector(".header-container__navbarpage");
const $c1ce9d969bfa6909$var$NavClose = document.querySelector(".header-container__navbarpage-close-btn-box-close");
$c1ce9d969bfa6909$var$NavBtn.addEventListener("click", function(e) {
    $c1ce9d969bfa6909$var$NavBarPage.classList.add("navopen");
});
$c1ce9d969bfa6909$var$NavClose.addEventListener("click", function(e) {
    $c1ce9d969bfa6909$var$NavBarPage.classList.remove("navopen");
});
// Nav Page Links
const $c1ce9d969bfa6909$var$linkBoxes = document.querySelectorAll(".header-contianer__navbarpage-navbox__link");
const $c1ce9d969bfa6909$var$linkText = document.querySelectorAll(".header-container__navbarpage-navbox-text");
const $c1ce9d969bfa6909$var$options = {
    root: null,
    threshold: 0.1
};
function $c1ce9d969bfa6909$var$callBack(entries, observer) {
    entries.forEach((entry)=>{
        if (entry.isIntersecting) $c1ce9d969bfa6909$var$linkText.forEach((text)=>{
            text.classList.add("show");
        });
        else $c1ce9d969bfa6909$var$linkText.forEach((text)=>{
            text.classList.remove("show");
        });
    });
}
const $c1ce9d969bfa6909$var$observer = new IntersectionObserver($c1ce9d969bfa6909$var$callBack, $c1ce9d969bfa6909$var$options);
$c1ce9d969bfa6909$var$linkBoxes.forEach((box)=>{
    $c1ce9d969bfa6909$var$observer.observe(box);
});
/** SECTION-TWO */ function $c1ce9d969bfa6909$var$Observerfun(options, callBack, Element) {
    // Add Error Handling
    if (!Element) {
        console.log("Element to observe is null or undefined");
        return null;
    }
    try {
        const observer = new IntersectionObserver(callBack, options);
        Element.forEach((ele)=>{
            observer.observe(ele);
            return observer;
        });
    } catch (error) {
        console.log("Error creating IntersectionObserver:", error);
        return null;
    }
}
const $c1ce9d969bfa6909$var$workBox = document.querySelectorAll(".section-two__work");
const $c1ce9d969bfa6909$var$Polygon = document.querySelector(".polygon");
// Add null checks before proceeding
if (!$c1ce9d969bfa6909$var$workBox || !$c1ce9d969bfa6909$var$Polygon) console.log("Required elements not found:", {
    workBox: !!$c1ce9d969bfa6909$var$workBox,
    Polygon: !!$c1ce9d969bfa6909$var$Polygon
});
else {
    const SectionTwoOptions = {
        root: null,
        threshold: Array.from({
            length: 21
        }, (_, i)=>i * 0.05)
    };
    function SectionTwoCallBack(entries) {
        entries.forEach((entry)=>{
            const ratio = entry.intersectionRatio;
            const poly = entry.target.children;
            if (poly.length > 1 && poly[1]) {
                const textBox = poly[1];
                const textChild = textBox.children;
                // Dynamic timing based on number of sentences
                const totalSentences = textChild.length;
                // Fixed total animation duration regardless of sentence count
                const totalAnimationTime = 0.8; // 80% of intersection ratio
                const delayBetween = totalAnimationTime / (totalSentences + 1);
                Array.from(textChild).forEach((child, index)=>{
                    /**v3 */ // Each sentence gets equal portion of the scroll progress
                    const start = index * delayBetween;
                    const duration = delayBetween * 2; // Each sentence animates for 2 delay periods
                    let progress = 0;
                    if (ratio > start) progress = Math.min(1, (ratio - start) / duration);
                    const translateY = (1 - progress) * 100;
                    const opacity = progress;
                    child.style.transform = `translateY(${translateY}px)`;
                    // child.style.opacity = opacity;
                    child.style.transition = `transform 0.5s cubic-bezier(0.19, 1, 0.22, 1), opacity 0.8s cubic-bezier(0.19, 1, 0.22, 1)`;
                });
            } else console.warn("poly[1] does not exist. Available children:", poly.length);
            /* clip-path: polygon(20% 0%, 80% 0%, 90% 60%, 10% 60%); */ poly[0].style.clipPath = `polygon(${20 - ratio * 30}% ${5 - ratio * 8}%, ${60 + ratio * 50}% ${20 - ratio * 25}%, ${70 + ratio * 40}% ${60 + ratio * 40}%, ${10 - ratio * 13}% ${60 + ratio * 40}%)`;
            poly[0].style.transition = `clip-path 0.5s ease`;
        });
    }
    // clip-path: polygon(20% 5%, 60% 20%, 70% 60%, 10% 60%);
    $c1ce9d969bfa6909$var$Observerfun(SectionTwoOptions, SectionTwoCallBack, $c1ce9d969bfa6909$var$workBox);
}
/**SECTION-THREE CURSOR BOX */ const $c1ce9d969bfa6909$var$SectionThree = document.querySelector(".section-three");
const $c1ce9d969bfa6909$var$SectionCursor = document.querySelector(".section-three__cursorBox-cursor");
$c1ce9d969bfa6909$var$SectionThree.addEventListener("mouseenter", function(event) {
    $c1ce9d969bfa6909$var$SectionCursor.style.display = `flex`;
    $c1ce9d969bfa6909$var$SectionCursor.style.position = "fixed";
    $c1ce9d969bfa6909$var$SectionCursor.style.transition = `display 1s ease`;
    console.log(event, "mouseenter");
});
$c1ce9d969bfa6909$var$SectionThree.addEventListener("mousemove", function(event) {
    const x = event.clientX;
    const y = event.clientY;
    $c1ce9d969bfa6909$var$SectionCursor.style.transform = `translate(${x}px, ${y}px)`;
    $c1ce9d969bfa6909$var$SectionCursor.style.transition = `transform 0.2s ease`;
    // SectionCursor.style.top = `${y}px`;
    // SectionCursor.style.left = `${x}px`;
    console.log("mouseIn");
});
$c1ce9d969bfa6909$var$SectionThree.addEventListener("mouseout", function(event) {
    // Check if the mouse is leaving the section-three element itself
    // and not just moving to a child element
    if (!$c1ce9d969bfa6909$var$SectionThree.contains(event.relatedTarget)) {
        console.log("Actually leaving section-three");
        $c1ce9d969bfa6909$var$SectionCursor.style.display = "none";
        $c1ce9d969bfa6909$var$SectionCursor.style.position = "absolute";
    }
});
// Smooth scroll for the entire page
window.addEventListener("scroll", function() {
// This enables smooth scrolling for wheel/touchpad
}, {
    passive: true
});
/** GSAP */ const $c1ce9d969bfa6909$var$ScreambleDuration = 3;
const $c1ce9d969bfa6909$var$ScrambleDelay = 1.4;
document.addEventListener("DOMContentLoaded", function() {
    (0, $4AGbv.gsap).registerPlugin((0, $iNA1s.ScrollTrigger), (0, $beOXE.ScrollSmoother), (0, $2PKE5.SplitText), (0, $249ec7e572a7bdb2$export$33be2495fb0a473a));
    let smoother = (0, $beOXE.ScrollSmoother).create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 2,
        smoothTouch: 0.1
    });
    (0, $4AGbv.gsap).to(".section-three__reveal-box", {
        scale: 0.5,
        delay: 5,
        duration: 0.5,
        scrollTrigger: {
            trigger: ".section-three",
            start: "top 0%",
            end: "100% 100%",
            scrub: 0.5,
            pin: ".section-three__reveal-box",
            toggleActions: "restart none none none"
        }
    });
    (0, $4AGbv.gsap).to(".section-three__textbox", {
        // your animation
        scrollTrigger: {
            trigger: ".section-three",
            start: "top 0%",
            end: "100% 100%",
            scrub: 0.5,
            pin: ".section-three__textbox"
        }
    });
    // ARCHIVE
    (0, $4AGbv.gsap).to(".archive__container", {
        scale: 0.9,
        duration: 0.5,
        scrollTrigger: {
            trigger: ".archive__container",
            start: "top 0%",
            end: "bottom 0%",
            pin: true,
            scrub: true,
            pinSpacing: false
        }
    });
    const splitElement = document.querySelectorAll(".split");
    splitElement.forEach((element, index)=>{
        // SPLIT TEXT
        let mySplitText = new (0, $2PKE5.SplitText)(element, {
            type: "chars"
        });
        let chars = mySplitText.chars;
        (0, $4AGbv.gsap).from(chars, {
            yPercent: 130,
            stagger: 0.05,
            duration: 0.5,
            // ease: "back",
            // delay: 1,
            scrollTrigger: {
                trigger: element,
                start: "top 100%",
                end: "bottom 40%",
                scrub: 0.5,
                toggleActions: "restart none none none"
            }
        });
    });
    /**SCRAMBLE TEXT */ const tl = (0, $4AGbv.gsap).timeline({
        id: "text-scramble"
    });
    tl.to("#text-scramble__onebox-textbox-text", {
        scrambleText: {
            text: `SENIOR `,
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl1 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-1"
    });
    tl1.to("#text-scramble-1__onebox-textbox-text", {
        scrambleText: {
            text: `GRAPHIC DESIGNER`,
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl2 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-2"
    });
    tl2.to("#text-scramble-2__onebox-textbox-text", {
        scrambleText: {
            text: "PROGRESS IS NOT A GOAL",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl3 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-3"
    });
    tl3.to("#text-scramble-3__onebox-textbox-text", {
        scrambleText: {
            text: "IT'S A CONSTANT",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl4 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-4"
    });
    tl4.to("#text-scramble-4__onebox-textbox-text", {
        scrambleText: {
            text: "WHAT I DO",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl5 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-5"
    });
    tl5.to("#text-scramble-5__onebox-textbox-text", {
        scrambleText: {
            text: "GRAPHIC DESINGING",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl6 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-6"
    });
    tl6.to("#text-scramble-6__onebox-textbox-text", {
        scrambleText: {
            text: "VIDEO EDITING",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl7 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-7"
    });
    tl7.to("#text-scramble-7__onebox-textbox-text", {
        scrambleText: {
            text: "MOTION DESIGNING",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl8 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-8"
    });
    tl8.to("#text-scramble-8__onebox-textbox-text", {
        scrambleText: {
            text: "3D MODELING",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl9 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-9"
    });
    tl9.to("#text-scramble-9__onebox-textbox-text", {
        scrambleText: {
            text: "EXPERTISE",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl10 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-10"
    });
    tl10.to("#text-scramble-10__onebox-textbox-text", {
        scrambleText: {
            text: "BRANDING",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl11 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-11"
    });
    tl11.to("#text-scramble-11__onebox-textbox-text", {
        scrambleText: {
            text: "PACKAGING DESIGNING",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl12 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-12"
    });
    tl12.to("#text-scramble-12__onebox-textbox-text", {
        scrambleText: {
            text: "DIGITAL CREATIVES",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
    const tl13 = (0, $4AGbv.gsap).timeline({
        id: "text-scramble-13"
    });
    tl13.to("#text-scramble-13__onebox-textbox-text", {
        scrambleText: {
            text: "MOTION DESIGN",
            // text: "{original}",
            chars: "lowerCase",
            speed: 0.4
        },
        delay: $c1ce9d969bfa6909$var$ScrambleDelay,
        duration: $c1ce9d969bfa6909$var$ScreambleDuration
    });
});
/** LINE EFFECTS */ const $c1ce9d969bfa6909$var$SectionTwo = document.querySelector(".section-two__work");
const $c1ce9d969bfa6909$var$SectionTwoLine = document.querySelector(".section-two__mainline");
const $c1ce9d969bfa6909$var$LineOptions = {
    root: null,
    threshold: 0.3
};
function $c1ce9d969bfa6909$var$LineCallback(entries, observer) {
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            $c1ce9d969bfa6909$var$SectionTwoLine.classList.add("lineani");
            // Remove observer after first trigger
            observer.unobserve($c1ce9d969bfa6909$var$SectionTwo);
        } else $c1ce9d969bfa6909$var$SectionTwoLine.classList.remove("lineani");
    });
}
const $c1ce9d969bfa6909$var$LineObserver = new IntersectionObserver($c1ce9d969bfa6909$var$LineCallback, $c1ce9d969bfa6909$var$LineOptions);
$c1ce9d969bfa6909$var$LineObserver.observe($c1ce9d969bfa6909$var$SectionTwo);
/** ARCHIVE */ const $c1ce9d969bfa6909$var$ArchiveSection = document.querySelector(".archive");
const $c1ce9d969bfa6909$var$ArchiveCursor = document.querySelector(".archive-cursor");
console.log($c1ce9d969bfa6909$var$ArchiveSection);
$c1ce9d969bfa6909$var$ArchiveSection.addEventListener("mouseenter", function(e) {
    console.log(e);
    $c1ce9d969bfa6909$var$ArchiveCursor.style.position = "fixed";
    $c1ce9d969bfa6909$var$ArchiveCursor.style.display = "block";
});
$c1ce9d969bfa6909$var$ArchiveSection.addEventListener("mousemove", function(e) {
    const x = e.clientX;
    const y = e.clientY;
    $c1ce9d969bfa6909$var$ArchiveCursor.style.transform = `translate(${x}px, ${y}px)`;
    $c1ce9d969bfa6909$var$ArchiveCursor.style.transition = "transform 0.3s ease";
});
$c1ce9d969bfa6909$var$ArchiveSection.addEventListener("mouseout", function(e) {
    console.log(e);
    $c1ce9d969bfa6909$var$ArchiveCursor.style.position = "absolute";
    $c1ce9d969bfa6909$var$ArchiveCursor.style.display = "none";
});


//# sourceMappingURL=repo.1dd5fb16.js.map
